import React from "react";
import Switch from "react-switch";
import BackendConnectionService from "../../ports/backend/backendConnectionService";
import { toast } from "react-toastify";
import Toastify from "../alerts/Toastify";
import ResponseProcessorService from "../../ports/backend/ResponseProcessorService";
import LocalStorageService from "../../ports/localStorage/localStorageService";


export default class InstanceConfigurationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            maintenance: false,
            requestInProgress: false,
            name: "",
            email: "",
            selected:  "",
            color: "",
            colorBold: ""
        };
    }

    componentDidMount() {
        this.setState({
            requestInProgress: true
        });
        
        BackendConnectionService.getInstanceConfiguration()
        .then((e) => {
            this.setState({
                maintenance: e.data.maintenance,
                name: e.data.name,
                email: e.data.adminEmail,
                selected: e.data.displayMethod,
                color: e.data.color,
                colorBold: e.data.colorBold
            });
        })
        .catch((e) => {
            ResponseProcessorService.processError(e);
            Toastify.error(toast, "Error al obtener la configuración del trámite " + this.props.tramite);
        }).finally(() => {
            this.setState({
                requestInProgress: false
            });
        });
    }

    attemptConfigurationChange() {
        let {maintenance, name, email, selected, color, colorBold} = this.state;
        const token = LocalStorageService.getUserToken();
        this.setState({ requestInProgress: true });
        const data = {
            "displayMethod": selected,
            "name": name,
            "adminEmail": email,
            "maintenance": maintenance,
            "color": color,
            "colorBold": colorBold
        }
        BackendConnectionService.updateInstanceConfiguration(token, data)
        .then((e) => {
            Toastify.success(toast, "Configuración actualizada correctamente.");
        }) 
        .catch((e) => {
            ResponseProcessorService.processError(e);
        }).finally(() => {
            this.setState({
                requestInProgress: false
            });
        });
    }

    handleMaintenance = (checked) => {
        this.setState({ maintenance: checked });
    };

    render() {
        let { maintenance, name, email, selected, requestInProgress, color, colorBold} = this.state;
        let button = (<button className="btn btn-success btn-block waves-effect waves-light" type="button" onClick={() => this.attemptConfigurationChange()}>Guardar cambios</button>);
        if(requestInProgress) {
            button = (<button className="btn btn-success btn-block waves-effect waves-light" type="button" disabled>Cargando...</button>);
        }
        return (
            <div className="card">
                <div className="card-body p-4">
                    <h5 className="mb-5 text-center">Configuración del sistema</h5>
                    <form>
                        <div className="form-group mb-4">
                            <label htmlFor="instanceName">Nombre del consulado</label>
                            <input type="text" className="form-control" id="instanceName" placeholder="Nombre del consulado" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                        </div>
                        <div className="form-group mb-4">
                            <label htmlFor="instanceEmail">Correo electrónico de contacto</label>
                            <input type="email" className="form-control" id="instanceEmail" placeholder="Correo electrónico de contacto" value={email} onChange={(e) => this.setState({ email: e.target.value })} />
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-color-input" className="col-md-3 col-form-label">Color</label>
                            <div className="col-md-9">
                                <input className="form-control" type="color" value={color} id="example-color-input" onChange={(e) => this.setState({ color: e.target.value })} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-color-input-2" className="col-md-3 col-form-label">Color Oscuro</label>
                            <div className="col-md-9">
                                <input className="form-control" type="color" value={colorBold} id="example-color-input-2" onChange={(e) => this.setState({ colorBold: e.target.value })} />
                            </div>
                        </div>
                        <div className="form-group row mb-0">
                            <label className="col-md-3 col-form-label">Identidad del consulado</label>
                            <div className="col-md-9">
                                <select className="custom-select" value={selected} onChange={(e) => this.setState({ selected: e.target.value })}>
                                    <option value="name">Mostrar texto</option>
                                    <option value="image">Mostrar logo</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group mt-4 row">
                            <div className="col-md-3">
                                <label className="me-2">Mantenimiento</label>
                            </div>
                            <div className="col-md-9">
                                <Switch
                                onChange={this.handleMaintenance}
                                checked={maintenance}
                                onColor="#4CAF50"
                                offColor="#ccc"
                                handleDiameter={22}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                height={28}
                                width={50}
                            />
                            </div>
                        </div>
                        
                        <div className="mt-4">
                            {button}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
